// extracted by mini-css-extract-plugin
export default {"main":"AppLoader_main__biZmT"};